import React from "react";
import { useTable } from "../../Components/useTable";

const WalletTransaction = () => {
  const type = "Wallet Transaction";
  const limitPerpage = 100;
  const pageRowslinit = [20 , 50 , 100];
  const headCells = [
    { id: "currentRcoin", numeric: false, label: "Current Rcoin" },
    { id: "currentDiamond", numeric: false, label: "Current Diamond" },
    { id: "quantity", numeric: false, label: "Quality" },
    { id: "amount", numeric: false, label: "Amount" },
    { id: "status", numeric: false, label: "Status" },
    { id: "type", numeric: false, label: "Type" },
    { id: "created", numeric: false, label: "Created" },
    { id: "updated", numeric: false, label: "Updated" },
    { id: "targetusercode", numeric: false, label: "User Code" },
    { id: "targetusername", numeric: false, label: "User Name" },
    { id: "photoUrl", numeric: false, label: "Picture" },
    { id: "fromusername", numeric: false, label: "User Name" },
    { id: "fromusercode", numeric: false, label: "FromUser Code" },
    { id: "pictureUrl", numeric: false, label: "User Picture" },
    // { id: "picture", numeric: false, label: "Gift Picture" },
    // { id: "giftname", numeric: false, label: "Gift Name" },
    { id: "giftdiamond", numeric: false, label: "Gift Diamond" },
    { id: "gifttype", numeric: false, label: "Gift Type" },
  ];

  const { tableUI } = useTable({
    headCells,
    type,
    limitPerpage,
    pageRowslinit,
  });

    
  return (
   <div className="admin-body">
        <div className="table-area">{tableUI}</div>
    </div>
  );
};

export default WalletTransaction;
